module.exports = __webpack_public_path__ + "static/img/products application_normal3.61f08246.jpg";